import styled from 'styled-components'

import { Description } from './CodeItems/styles'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const FullWidthField = styled.div`
  grid-column: 1 / -1;
`

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${props => props.theme.spacing.sp16};

  .MuiSelect-select ${Description} {
    display: none;
  }
`
